import env from '@/config/env';
import SliderPrincipal from '@/graphql/tabela/queries/SliderPrincipal.gql';
import SliderMelhorDesconto from '@/graphql/tabela/queries/SliderMelhorDesconto.gql';

export const Types = {
  LOADING: 'LOADING',
  SLIDER_ADD: 'SLIDER_ADD',
  SLIDER_CLEAR: 'SLIDER_CLEAR',
};

const CATEGORIA_ACESSORIOS = 24;

// Acessório não tem plano escolhido no cadastro e segue no plano padrão.
// Os demais usam o plano gravado no banner, caindo no padrão quando não houver.
function planosDoBanner(banner) {
  const categoria = banner.cel && banner.cel.categoria;
  if (categoria && categoria.id === CATEGORIA_ACESSORIOS) {
    return null;
  }
  if (banner.planos && banner.planos.length > 0) {
    return banner.planos.map(plano => plano.id);
  }
  return null;
}

export default {
  namespaced: true,
  state: {
    loading: false,
    data: [],
  },
  getters: {
    loading: state => state.loading,
    data: state => state.data,
  },
  mutations: {
    [Types.LOADING](state, payload) {
      state.loading = payload.loading;
    },
    [Types.SLIDER_ADD](state, payload) {
      state.data = payload.data;
    },
    [Types.SLIDER_CLEAR](state) {
      state.data = [];
    },
  },
  actions: {
    async getSliderPrincipal({ commit, dispatch }, { tabela, ufId }) {
      commit(Types.SLIDER_CLEAR);
      commit(Types.LOADING, { loading: true });
      try {
        console.log(ufId);
        const query = await env.tabela.query({
          query: SliderPrincipal,
          variables: {
            tabela,
            ufId: [ufId],
            paginate: 5,
            page: 1,
          },
          fetchPolicy: 'no-cache'
        });

        const { data } = query.data.slider;
        if(data.length > 0) {
          const slider = await Promise.all(
            data.map(async celular => {
              const planos = await dispatch(
                'vcSliderPlanos/getPlanos',
                {
                  tabela,
                  celular: celular.cel.id,
                  planos: planosDoBanner(celular),
                },
                { root: true },
              );
              return { ...celular, planos };
            }),
          );
          commit(Types.SLIDER_ADD, { data: slider });
          commit(Types.LOADING, { loading: false });
        } else {
          dispatch('getSliderMelhorDesconto', { tabela })
        }
      } catch (e) {
        dispatch(
          'error/setError',
          { message: 'Não foi possível carregar os destaques' },
          { root: true },
        );
      }
    },

    async getSliderMelhorDesconto({ commit, dispatch, rootState }, { tabela }) {
      const planos = await rootState.vcSliderPlanos.defaultPlanos;
      const desconto = await env.tabela.query({
        query: SliderMelhorDesconto,
        variables: {
          tabela,
          planos,
          paginate: 3,
          page: 1,
        },
        fetchPolicy: 'no-cache'
      });
      const { data } = desconto.data.slider;
      const slider = { data, sliderMelhorDesconto: true }
      console.log(slider)
      commit(Types.SLIDER_ADD, { data: slider });
          commit(Types.LOADING, { loading: false });
    }
  },
};
